<template>
  <v-row>
    <v-col cols="12">
      <v-textarea
        label="Share your feedback here (optional)"
        v-model="question.value"
        single-line
        outlined
        auto-grow
        :rows="5"
        required
        full-width
        hide-details
      ></v-textarea>
    </v-col>
    <v-col cols="12" class="secondarytext--text">
      <v-icon color="secondarytext">info</v-icon>
      We'll hide your identity when we share this feedback with company admins
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SurveyFeedback",
  props: {},
  data: () => ({
    feedback: ""
  }),
  computed: mapGetters({
    question: "survey/current_step",
    is_preview: "survey/is_preview"
  }),
  methods: {}
};
</script>
